(function () {
  'use strict';

  var TAB_LABEL_SAFETY_GAP = 4;

  function getLabelTextWidth(label) {
    var range = document.createRange();
    range.selectNodeContents(label);

    return Math.ceil(range.getBoundingClientRect().width);
  }

  function tabLabelNeedsCompactSize(tab) {
    var label = tab.querySelector('.main-nav-menu__tab-label');
    if (!label) return false;

    var labelTextWidth = getLabelTextWidth(label);
    if (!labelTextWidth || !label.clientWidth) return false;

    return labelTextWidth + TAB_LABEL_SAFETY_GAP > label.clientWidth;
  }

  function fitMenuTabLabels(menu) {
    var tabs = Array.from(menu.querySelectorAll('[data-main-nav-tab]'));

    menu.classList.remove('main-nav-menu--compact-tabs');

    var shouldCompactAllTabs = tabs.some(tabLabelNeedsCompactSize);
    menu.classList.toggle('main-nav-menu--compact-tabs', shouldCompactAllTabs);
  }

  function activateTab(menu, tab) {
    var tabId = tab.getAttribute('data-main-nav-tab');

    menu.querySelectorAll('[data-main-nav-tab]').forEach(function (item) {
      item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
      item.setAttribute('tabindex', item === tab ? '0' : '-1');
    });

    menu.querySelectorAll('[data-main-nav-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-main-nav-panel') !== tabId;
    });

    menu.querySelectorAll('[data-main-nav-promo]').forEach(function (promo) {
      promo.hidden = promo.getAttribute('data-main-nav-promo') !== tabId;
    });
  }

  function initMenu(menu) {
    if (menu.dataset.mainNavReady === 'true') return;
    menu.dataset.mainNavReady = 'true';

    var tabs = Array.from(menu.querySelectorAll('[data-main-nav-tab]'));
    if (!tabs.length) return;

    fitMenuTabLabels(menu);

    if ('ResizeObserver' in window) {
      var tabsContainer = menu.querySelector('.main-nav-menu__tabs');

      if (tabsContainer) {
        menu.mainNavTabResizeObserver = new ResizeObserver(function () {
          fitMenuTabLabels(menu);
        });
        menu.mainNavTabResizeObserver.observe(tabsContainer);
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('pointerenter', function () {
        activateTab(menu, tab);
      });

      tab.addEventListener('click', function () {
        activateTab(menu, tab);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex;

        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(menu, tabs[nextIndex]);
        tabs[nextIndex].focus();
      });
    });

    activateTab(menu, tabs[0]);
  }

  function initHeader(header) {
    if (!header || header.dataset.mainNavigationReady === 'true') return;
    header.dataset.mainNavigationReady = 'true';

    header.querySelectorAll('[data-main-nav-menu]').forEach(initMenu);

    header.querySelectorAll('[data-main-nav-trigger]').forEach(function (trigger) {
      var item = trigger.closest('.nav-list__item');
      var menu = item && item.querySelector('[data-main-nav-menu]');
      if (!menu) return;

      function setOpen(isOpen) {
        trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        menu.setAttribute('data-menu-open', isOpen ? 'true' : 'false');
      }

      item.addEventListener('pointerenter', function () {
        setOpen(true);
      });

      item.addEventListener('pointerleave', function () {
        if (!item.contains(document.activeElement)) setOpen(false);
      });

      item.addEventListener('focusin', function () {
        setOpen(true);
      });

      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(false);
      });

      item.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        setOpen(false);
        trigger.focus();
      });
    });
  }

  function init() {
    document.querySelectorAll('.site-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      document.querySelectorAll('[data-main-nav-menu]').forEach(fitMenuTabLabels);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHeader(event.target.querySelector('.site-header') || event.target.closest('.site-header'));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-main-nav-menu]').forEach(function (menu) {
      if (menu.mainNavTabResizeObserver) menu.mainNavTabResizeObserver.disconnect();
    });
  });
})();
